export default __webpack_public_path__ + "static/media/icon-add-to-library-white.2816b80b.svg";